<template>
  <div>
    <el-input v-model="inputValProxy" clearable :placeholder="placeholder" v-bind="$attrs">
      <template #prepend>
        <el-select size="mini" v-model="prependProxy" :style="{ width: prependWidth }">
          <el-option
            v-for="option in options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
      </template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'PrependInput',
  props: {
    value: {
      // 支持旧版 string，也支持新版 object:
      // { inputVal: string, prepend: string }
      type: [String, Object],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    prependWidth: {
      type: String,
      default: '100px',
    },
  },
  // Vue2 自定义组件 v-model 默认协议：prop:value + event:input
  // 这里用 input 事件保证 SearchRenderer 里的 v-model 能正常回写 query
  emits: ['input'],
  computed: {
    normalizedValue: {
      get() {
        const first = (this.options && this.options[0] && this.options[0].value) || ''
        if (this.value && typeof this.value === 'object') {
          return {
            inputVal: this.value.inputVal != null ? this.value.inputVal : '',
            prepend: this.value.prepend != null ? this.value.prepend : first,
          }
        }
        return {
          inputVal: this.value != null ? thi.value : '',
          prepend: first,
        }
      },
    },
    inputValProxy: {
      get() {
        return this.normalizedValue.inputVal
      },
      set(val) {
        this.$emit('input', { ...this.normalizedValue, inputVal: val })
      },
    },
    prependProxy: {
      get() {
        return this.normalizedValue.prepend
      },
      set(val) {
        this.$emit('input', { ...this.normalizedValue, prepend: val })
      },
    },
    placeholder() {
      const opt = (this.options || []).find(option => option.value === this.prependProxy)
      return opt ? `输入${opt.label}` : '请输入'
    },
  },
}
</script>

<style scoped>
.prepend-input {
  width: 100%;
}
</style>
